import { render, staticRenderFns } from "./Statistics-on-sectoral-issues.vue?vue&type=template&id=894893f0&scoped=true"
import script from "./Statistics-on-sectoral-issues.vue?vue&type=script&lang=js"
export * from "./Statistics-on-sectoral-issues.vue?vue&type=script&lang=js"
import style0 from "./Statistics-on-sectoral-issues.vue?vue&type=style&index=0&id=894893f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894893f0",
  null
  
)

export default component.exports